import { useLingui } from '@lingui/react/macro';
import { MediaManagerTemplate } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import { useDeleteMediaManagerTemplateMutation } from 'modules/manager/store/media-manager-api';
import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';

/** The group refetches by the template's tag — the group provides the tags of its templates (IMGM-1515). */
function useDeleteTemplateModal() {
  const { t } = useLingui();
  const [deleteTemplate, { isLoading }] = useDeleteMediaManagerTemplateMutation();
  const [template, setTemplate] = useState<MediaManagerTemplate | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback((next: MediaManagerTemplate) => {
    setTemplate(next);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const onSubmit = useCallback(async () => {
    if (!template) return;
    try {
      await deleteTemplate(template.id).unwrap();
      close();
    } catch (error) {
      console.error('Failed to delete media manager template:', error);
    }
  }, [template, deleteTemplate, close]);

  const templateName = template?.name;

  return {
    open,
    close,
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={templateName ? t`Удалить шаблон «${templateName}»?` : t`Удалить шаблон?`}
        description={t`Это действие необратимо.`}
        isLoading={isLoading}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
  };
}

export default useDeleteTemplateModal;
